module.exports = __webpack_public_path__ + "4d5cbf386d6bc09c5275862c7c287bb1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-steve-04.jpg
 ** module id = 374
 ** module chunks = 0
 **/